import { createCtx } from '@shared/util/context';
import { FieldPatchContextValue } from './types';

/**
 * Two ways in, on purpose.
 *
 * `useFieldPatches` throws when the provider is missing, because a producer emitting into nothing
 * is a bug that would otherwise look like an agent that answered and did nothing. The applier reads
 * `FieldPatchContext` directly and no-ops when it is absent, because a form rendered without the
 * provider — a unit test, a preview — is not broken, it simply has no patches to receive.
 */
export const [useFieldPatches, FieldPatchContextProvider, FieldPatchContext] =
  createCtx<FieldPatchContextValue>();
